import { queries } from 'apollo';
import * as React from 'react';
import { Query, QueryResult } from 'react-apollo';
import { Subtract } from 'utility-types';

interface IGalleryPageDataResult {
  fetch: {
    Common: {
      Gallery: {
        BackgroundColor: string;
      } | null;
    };
    Country: {
      AboutPage: {
        GalleryPage: {
          Carousels: Array<{
            _meta: {
              id: string;
            };
            Title: string;
            Images: Array<{
              Title: string;
              Image: {
                src: string;
              };
            }>;
          }>;
        } | null;
      } | null;
    };
  };
}

interface IVariables {
  filters: {
    UrlKey: string;
  };
}

interface IRequiredProps {
  country: string;
}

export type WithGalleryPageQueryProps = QueryResult<IGalleryPageDataResult>;

class GalleryPageQuery extends Query<IGalleryPageDataResult, IVariables> {}

const withGalleryPageQuery = <P extends WithGalleryPageQueryProps>(
  Component: React.ComponentType<P>
): React.SFC<
  Subtract<P, WithGalleryPageQueryProps> & IRequiredProps
> => props => {
  const { country } = props;
  return (
    <GalleryPageQuery
      query={queries.GET_GALLERY_PAGE_DATA}
      variables={{
        filters: { UrlKey: country }
      }}
    >
      {providedProps => <Component {...providedProps} {...props as any} />}
    </GalleryPageQuery>
  );
};

export default withGalleryPageQuery;



// WEBPACK FOOTER //
// ./src/enhancers/withGalleryPageQuery.tsx